import { signInWithRedirect } from 'aws-amplify/auth'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'

import styles from './federated-buttons.module.scss'
import { Button } from '@/components/styleguide/Button'
import { ButtonHierarchy } from '@/components/styleguide/Button/Button'
import { addToDataLayer } from '@/lib/utilities/vehicle'
import { Size } from '@/types/system'

export const Buttons = ({
  savePage,
  toggleSocialLogin,
  signUp = false,
  googleOnly = false,
  facebookOnly = false,
  mobileVersion = false,
}) => {
  const router = useRouter()
  const google = e => {
    e.preventDefault()
    addToDataLayer({
      event: `social-${signUp ? 'sign-up' : 'login'}`,
      label: 'google',
    })
    savePage(router.asPath)
    toggleSocialLogin()
    signInWithRedirect({ provider: 'Google' })
  }

  const facebook = e => {
    e.preventDefault()
    addToDataLayer({
      event: `social-${signUp ? 'sign-up' : 'login'}`,
      label: 'facebook',
    })
    savePage(router.asPath)
    toggleSocialLogin()
    signInWithRedirect({ provider: 'Facebook' })
  }

  const bothButtonsAvailable = !googleOnly && !facebookOnly

  return (
    <div
      className={`${styles.container} ${mobileVersion ? styles['mobile-version-container'] : ''}`}>
      {(bothButtonsAvailable || googleOnly) && (
        <Button
          label="Continue with Google"
          onClick={google}
          size={Size.Large}
          hierarchy={ButtonHierarchy.BezeledGray}
        />
      )}
      {(bothButtonsAvailable || facebookOnly) && (
        <Button
          label="Continue with Facebook"
          onClick={facebook}
          size={Size.Large}
          hierarchy={ButtonHierarchy.BezeledGray}
        />
      )}
    </div>
  )
}

Buttons.propTypes = {
  savePage: PropTypes.func.isRequired,
  toggleSocialLogin: PropTypes.func.isRequired,
  googleOnly: PropTypes.bool,
  facebookOnly: PropTypes.bool,
  signUp: PropTypes.bool,
  mobileVersion: PropTypes.bool,
}
